export class TravelPolicyMdl {
   public RegNo: string;
   public ProposalNo: string;
   public InsuredName: string;
   public PolicyNo: string;
   public PolicyFrom: string;
   public PolicyTo: string;
   public PolicyPath: string;
   public isDownload: boolean;
   public Plan: string;
   public Zone: string;
   public isforRenewal: boolean;
   public isShow: boolean;
   public PolicyStatus: string;
   public Lang: string;
   public QueryString: string;

   public Decisionstatus: string;
   public TotalRefundAmount: string;
   public VATREFUNDAMOUNT: string;
   public EndorsementId: string;
   public BankDesc_Eng: string;
   public IBANNumber: string;
   public EndorsementDate: string;
   public RefundPremium: string;
   public DecisionDate: string;
   public CanReasonDesc: string;
   
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/TravelPolicyMdl.ts